import AutoAwesomeMosaicIcon from "@mui/icons-material/AutoAwesomeMosaic";
import {
  DonutSmall,
  Notes,
  AccountCircle,
  PieChart,
  CropPortrait,
  Image,
  ChromeReaderMode,
  FilterList,
  Description,
  Palette,
  AttachFile,
} from "@mui/icons-material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { SectionsPanel } from "../panel/Sections";
import { NotesPanel } from "../panel/Notes";
import { UsersPanel } from "../panel/Users";
import { GenerateClippingPanel } from "../panel/Clipping";
import { PaysPanel } from "../panel/Pays";
import { CartonesPanel } from "../panel/Cartones";
import { IndicatorPanel } from "../panel/Indicator";
import { PortadasPanel } from "../panel/Portadas";
import { FilterPanel } from "../panel/Filter";
import { ClonationsPanel } from '../panel/Clonations'
import moment from "moment";
import { PanelDocument } from "../../editor/selectaAdmin/panelDocumentManagment/PanelDocument";
import { StylesPanel } from "../../editor/selectaAdmin/StylesPanel";
import { MDM } from "../panel/MDM";

const ROLES = {
  ADMIN: "admin",
  EDITOR: "editor",
};

const PANEL_IDS = {
  GENERAL: 0,
  SECCIONES: 1,
  NOTAS: 2,
  CLONAR: 3,
  PAYS: 4,
  CARTONES: 5,
  INDICADORES: 6,
  PORTADAS: 7,
  USUARIOS: 8,
  DOCUMENTOS: 9,
  ESTILOS: 10,
  FILTROS: 11,
  CLIPPING: 12,
  MDM: 13,
};

export const filteredListItems = (rol) => {
  const allItems = [
    {
      id: PANEL_IDS.GENERAL,
      name: "General",
      icon: <DonutSmall />,
    },
    {
      id: PANEL_IDS.SECCIONES,
      name: "Secciones",
      icon: <AutoAwesomeMosaicIcon />,
    },
    {
      id: PANEL_IDS.NOTAS,
      name: "Notas",
      icon: <Notes />,
    },
    {
      id: PANEL_IDS.CLONAR,
      name: "Clonar",
      icon: <ContentCopyIcon />,
      adminOnly: true,
    },
    {
      id: PANEL_IDS.PAYS,
      name: "Pays",
      icon: <PieChart />,
      adminOnly: true,
    },
    {
      id: PANEL_IDS.CARTONES,
      name: "Cartones",
      icon: <CropPortrait />,
      adminOnly: true,
    },
    {
      id: PANEL_IDS.INDICADORES,
      name: "Indicadores",
      icon: <Image />,
      adminOnly: true,
    },
    {
      id: PANEL_IDS.PORTADAS,
      name: "Portadas",
      icon: <ChromeReaderMode />,
      adminOnly: true,
    },
    {
      id: PANEL_IDS.USUARIOS,
      name: "Usuarios",
      icon: <AccountCircle />,
      adminOnly: true,
    },
    {
      id: PANEL_IDS.DOCUMENTOS,
      name: "Documentos",
      icon: <Description />,
    },
    {
      id: PANEL_IDS.ESTILOS,
      name: "Estilos",
      icon: <Palette />,
    },
    {
      id: PANEL_IDS.FILTROS,
      name: "Filtros",
      icon: <FilterList />,
    },
    {
      id: PANEL_IDS.CLIPPING,
      name: "Clipping",
      icon: <AttachFile />,
      adminOnly: true,
    },
    {
      id: PANEL_IDS.MDM,
      name: "Complemento DOC",
      icon: <AutoAwesomeMosaicIcon />,
      adminOnly: true,
    },
  ];

  return allItems.filter((item) => {
    if (item.adminOnly) return rol === ROLES.ADMIN;
    if (item.editorOnly) return rol === ROLES.EDITOR;
    return true;
  });
};

export const contentMap = (token, idDocument, rol, nameDocument, onDocumentsChange) => {
  const date = moment().format("YYYY-MM-DD");
  const hasPermission = (requiredRole) => {
    return rol === requiredRole;
  };

  const allPanels = {
    [PANEL_IDS.SECCIONES]: (
      <SectionsPanel token={token} idDocument={idDocument} />
    ),
    [PANEL_IDS.NOTAS]: (
      <NotesPanel
        token={token}
        date={date}
        idDocument={idDocument}
        nameDocument={nameDocument}
      />
    ),

    ...(hasPermission(ROLES.ADMIN) && {
      [PANEL_IDS.CLONAR]: (
        <ClonationsPanel
          token={token}
          date={date}
          idDocument={idDocument}
          nameDocument={nameDocument}
        />
      ),
      [PANEL_IDS.CLIPPING]: <GenerateClippingPanel token={token} />,
      [PANEL_IDS.PAYS]: (
        <PaysPanel token={token} date={date} idDocument={idDocument} />
      ),
      [PANEL_IDS.CARTONES]: (
        <CartonesPanel token={token} date={date} idDocument={idDocument} />
      ),
      [PANEL_IDS.INDICADORES]: (
        <IndicatorPanel token={token} date={date} idDocument={idDocument} />
      ),
      [PANEL_IDS.PORTADAS]: (
        <PortadasPanel token={token} idDocument={idDocument} />
      ),
      [PANEL_IDS.USUARIOS]: <UsersPanel token={token} />,
      [PANEL_IDS.MDM]: <MDM token={token} idDocument={idDocument} />,
    }),

    ...((hasPermission(ROLES.EDITOR) || hasPermission(ROLES.ADMIN)) && {
      [PANEL_IDS.DOCUMENTOS]: (
        <PanelDocument
          token={token}
          date={date}
          idDocument={idDocument}
          onCreate={onDocumentsChange}
          onUpdate={onDocumentsChange}
          onDelete={onDocumentsChange}
        />
      ),
      [PANEL_IDS.ESTILOS]: (
        <StylesPanel
          token={token}
          date={date}
          idDocument={idDocument}
          nameDocument={nameDocument}
        />
      ),
      [PANEL_IDS.FILTROS]: (
        <FilterPanel token={token} idDocument={idDocument} nameDocument={nameDocument} />
      ),
    }),
  };

  return allPanels;
};

export const isPanelAccessible = (panelId, rol) => {
  const items = filteredListItems(rol);
  return items.some((item) => item.id === panelId);
};